<!--
 * @Date: 2020-08-20 18:27:29
 * @Author: MX
 * @LastEditTime: 2023-08-08 18:23:54
 * @Description: 首页-底部
-->
<template>
  <Footer>
    <div class="content-wrap">
      <div class="foot-logo-box">
        <div class="foot-logo">
          <img style="width: 350px;" src="@/assets/images/home/logo/logo.png" alt=""/>
        </div>
        <div class="name-style">
          OPEN & SHARE
        </div>
<!--        <div class="email-font">-->
<!--          {{ $lang('ISV&平台业务对接请联系') + '：june.tang@jtexpress.com' }}<br />-->
<!--          {{ $lang('品牌客户&全国散件业务对接请联系') + '：westbrook.tang@jtexpress.com' }}-->
<!--        </div>-->
      </div>
      <div class="url-box">
        <div class="box-li">
          <div class="first-box">{{ $lang('友情链接') }}</div>
          <div :class="['first-border', moveIndex === 1 ? 'moveStart' : '', moveIndex === -1 ? 'moveEnd' : '']"></div>
          <!-- <div class="other-box" @mouseover="mouseOver(1)" @mouseleave="mouseLeave(-1)" @click="goWebsite"><a class="jtexpress" href="https://www.jtexpress.com" target="_" >极兔官网</a></div> -->
          <div class="other-box" @mouseover="mouseOver(1)" @mouseleave="mouseLeave(-1)" @click="goWebsite">{{ $lang('极兔官网') }}</div>
        </div>
        <div class="box-li">
          <div class="first-box">{{ $lang('新手入门') }}</div>
          <div :class="['first-border', moveIndex === 2 ? 'moveStart' : '', moveIndex === -2 ? 'moveEnd' : '']"></div>
          <!-- <div class="other-box" @mouseover="mouseOver(2)" @mouseleave="mouseLeave(-2)">平台简介</div> -->
          <div class="other-box" @mouseover="mouseOver(2)" @mouseleave="mouseLeave(-2)" @click="jump('/helpCenter', 1)">{{ $lang('新手指引') }}</div>
          <div class="other-box" @mouseover="mouseOver(2)" @mouseleave="mouseLeave(-2)" @click="jump('/helpCenter')">{{ $lang('帮助中心') }}</div>
        </div>
        <div class="box-li">
          <div class="first-box">{{ $lang('技术支持') }}</div>
          <div :class="['first-border', moveIndex === 3 ? 'moveStart' : '', moveIndex === -3 ? 'moveEnd' : '']"></div>
          <div class="other-box" @mouseover="mouseOver(3)" @mouseleave="mouseLeave(-3)" @click="jump('/apiDoc/index')">{{ $lang('API文档') }}</div>
          <div class="other-box" @mouseover="mouseOver(3)" @mouseleave="mouseLeave(-3)" @click="jump('/helpCenter')">{{ $lang('签名工具') }}</div>
<!--          <div class="other-box" @mouseover="mouseOver(3)" @mouseleave="mouseLeave(-3)" @click="jump('/helpCenter', 1)">{{ $lang('开发文档') }}</div>-->
        </div>
        <div class="box-li">
          <div class="first-box">{{ $lang('帮助中心') }}</div>
          <div :class="['first-border', moveIndex === 4 ? 'moveStart' : '', moveIndex === -4 ? 'moveEnd' : '']"></div>
<!--          <div class="other-box" @mouseover="mouseOver(4)" @mouseleave="mouseLeave(-4)" @click="jump('/solution')">{{ $lang('解决方案') }}</div>-->
          <div class="other-box" @mouseover="mouseOver(4)" @mouseleave="mouseLeave(-4)" @click="jump('/helpCenter', 2)">{{ $lang('常见问题') }}</div>
          <!-- <div class="other-box" @mouseover="mouseOver(4)" @mouseleave="mouseLeave(-4)">联系我们</div> -->
        </div>
      </div>

<!--      <div class="footer-copy">-->
<!--        <span class="mrl24">{{ $lang('总部地址：上海市青浦区华新镇华隆路1777号5幢1003') }}</span>-->
<!--      </div>-->
    </div>
  </Footer>
</template>

<script type="text/javascript">
export default {
  components: { },
  data() {
    return {
      moveIndex: 0
    }
  },
  methods:{
    goWebsite() {
      window.open("https://jtexpress.co.th/", "_blank");
    },
    goHelp(){
      this.$router.push({path:"/helpCenter"})
    },
    mouseOver(index) {
      this.moveIndex = index
    },
    mouseLeave(index) {
      this.moveIndex = index
    },
    jump(path, id) {
      if (id) {
        this.$router.push({ path, query: { id } })
      } else {
        this.$router.push({ path })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
Footer{
  width: 100%;
  height: 301px;
  background: #2b2d42;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #ffffff;
  .content-wrap{
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .foot-logo-box {
    width: 350px;
    padding-top: 80px;
  }
  .foot-logo {
    color: #E60000;
    .iconjitulogo_fanbai {
      font-size: 23px;
    }
    .iconlogo_kaifangpingtaifanbai {
      font-size: 23px;
      border-left: 1px solid #E60000;
      margin-left: 20px;
      padding-left: 20px;
    }
  }
  .name-style {
    padding-left: 8px;
    padding-top: 12px;
    letter-spacing: 18px;
    font-weight: 800;
  }
  .email-font {
    padding-left: 5px;
    margin-top: 20px;
  }
  .url-box {
    display: flex;
    justify-content: space-between;
    width: 600px;
    padding-top: 50px;
    .box-li {
      .first-box {
        height: 40px;
        line-height: 50px;
        user-select: none;
      }
      .first-border {
        width: 25px;
        height: 2px;
        border-radius: 6px;
        background-color: #E60000;
      }
      .other-box {
        padding-top: 10px;
        cursor: pointer;
        user-select: none;
      }
      .other-box:hover {
        color: #E60000;
      }
      .other-box a:hover {
        color: #E60000;
      }
    }
  }
  .footer-help{
    position: absolute;
    bottom: 36px;
    left: 0px;
    opacity: 0.5;
    .jtexpress{
      color: #ffffff;
      text-decoration: none;
    }
  }
  .footer-ban{
    opacity: 0.5;
  }
  .footer-copy{
    opacity: 0.5;
  }
  .mrl24{
    margin-left: 24px;
  }
  a {
    text-decoration:none;
    color: #ffffff;
  }
}
@keyframes moveOver {
  from { width: 25px; }
  to { width: 55px; }
}
@keyframes moveleave {
  from { width: 55px; }
  to { width: 25px; }
}
.moveStart {
  animation-name: moveOver;
  animation-duration: 0.5s;
  animation-fill-mode:forwards;
}
.moveEnd {
  animation-name: moveleave;
  animation-duration: 0.5s;
  animation-fill-mode:forwards;
}
</style>
